module.exports = __webpack_public_path__ + "img/sham.3601c884.png";